// DocContext.jsx
import React from "react";

const DocContext = React.createContext();

export default DocContext;

